import EventEmitter from './EventEmitter.js'

/**
 * 一个简单的游戏循环，
 * 在每一帧上更新时间和触发游戏逻辑的更新和渲染。
 * tick()方法负责计算时间差、触发游戏逻辑，
 * stop()方法用于停止游戏循环。
 */
export default class Time extends EventEmitter
{
    constructor()
    {
        super()

        this.start = Date.now()
        this.current = this.start
        this.elapsed = 0
        this.delta = 16

        this.tick = this.tick.bind(this)
        this.tick()
    }

    tick()
    {
        this.ticker = window.requestAnimationFrame(this.tick)

        const current = Date.now()

        this.delta = current - this.current
        this.elapsed = current - this.start
        this.current = current

        if(this.delta > 60)
        {
            this.delta = 60
        }

        this.trigger('tick')
    }

    stop()
    {
        window.cancelAnimationFrame(this.ticker)
    }
}
